export default "__VITE_ASSET__BQcPb8Ob__"